import React, { useState } from "react";
import axios from "axios";
import { FaEnvelope } from "react-icons/fa";
import "./ContactForm.css";

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    acceptPolicy: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.acceptPolicy) {
      alert("You must accept the privacy policy.");
      return;
    }

    try {
      await axios.post("https://automotive-backend-production.up.railway.app/contact", formData);
      alert("Message sent successfully!");
      setFormData({ name: "", email: "", phone: "", message: "", acceptPolicy: false });
    } catch (err) {
      console.error(err);
      alert("Failed to send message.");
    }
  };

  return (
    <div className="container my-5">
      <div className="row shadow rounded-4 bg-white">
        {/* Left Side: Form */}
        <div className="col-md-6 p-4 border-end">
          <h4 className="mb-4 fw-bold custom-text-dark">Get in Touch</h4>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label fw-semibold">Name</label>
              <input type="text" className="form-control" name="name" required value={formData.name} onChange={handleChange} />
            </div>
            <div className="mb-3">
              <label className="form-label fw-semibold">Email</label>
              <input type="email" className="form-control" name="email" required value={formData.email} onChange={handleChange} />
            </div>
            <div className="mb-3">
              <label className="form-label fw-semibold">Phone</label>
              <input type="text" className="form-control" name="phone" required value={formData.phone} onChange={handleChange} />
            </div>
            <div className="mb-3">
              <label className="form-label fw-semibold">Message</label>
              <textarea className="form-control" name="message" rows="4" required value={formData.message} onChange={handleChange}></textarea>
            </div>
            <div className="form-check mb-3">
              <input type="checkbox" className="form-check-input" id="policyCheck" name="acceptPolicy" checked={formData.acceptPolicy} onChange={handleChange} />
              <label className="form-check-label" htmlFor="policyCheck">
                I accept the privacy policy
              </label>
            </div>
            <button type="submit" className="btn custom-send-btn w-100 fw-bold">Send</button>
          </form>
        </div>

        {/* Right Side: Email Icon */}
        <div className="col-md-6 d-flex flex-column justify-content-center align-items-center p-4">
          <FaEnvelope
            size={64}
            className="custom-icon-dark mb-3"
            onClick={() => window.location.href = "mailto:info@shipmentsolutionsllc.com"}
            style={{ cursor: "pointer" }}
          />
          <p className="text-secondary">info@shipmentsolutionsllc.com</p>
        </div>
      </div>
    </div>
  );
}
